import $ from 'jquery';
import Vue from 'vue';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import VueAppHead from '~/src/custom/vue/apps/header-search-bar.js';
import VApp from '~/src/custom/vue/apps/containers/nav-header-search-app.vue';
// connect vue component and init app
Vue.component('app', VApp);
// console.log('layoutjs');
if (document.getElementById('search-typeahead-header-app') !== null) {
    VueAppHead.$mount('#search-typeahead-header-app');
} 
class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');

		this.skipLink = $('.skip-link');
		this.scrollTop = this.$header.scrollTop;

		this.$nav = $('.nav');
		this.$navHeader = $('.nav-in-header');
		this.$primaryNavItem = $('.primary-nav > li');
		this.$primaryNavItemLink = $('.primary-nav > li > a');
		this.$navToggle = $('.js-nav-toggle');
		this.$navToggleChildren = $('.js-nav-toggle-children');
		this.$megaMenuClose = $('.js-close-megamenu');
		this.$jumpLink = $('.jump-link');

		this.$search = $('.js-search');
		this.$searchToggle = $('.js-search-toggle');

		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;

		this.$footerAccordionItem = $('.js-footer-accordion > li > a.footer-nav-item--parent');

        this.timer = 0;
    }

    init() {
		this.bindEvents();

		this.setCornerHeight();
		this.setWidgetHeight();
		this.prepExternalLinks();
		this.setUpcomingEvents();
        this.setupLiveChat();
    }

    bindEvents() {
		this.$navToggle.on('click', e => { e.stopPropagation(); this.toggleNav(e); });
		this.$megaMenuClose.on('click', e => { e.stopPropagation(); this.closeMegaMenu(e); });
		this.$navToggleChildren.on('click', e => { this.mobileNavItem(e); });
		this.$jumpLink.on('click', e => { this.jumpLink(e); });

		// on menu enter
		this.$primaryNavItemLink.on('keydown', e => { this.tabbingNav(e); });
		this.$searchToggle.on('click', e => { this.toggleSearch(e); });

        this.$footerAccordionItem.on('click', e => { this.footerAccordion(e); });
		
		let delayDuration;
		if (!document.URL.includes('talk-about-vaping')) {
			delayDuration = 300;  // everything is typically set to 300
		} else {
			delayDuration = 50; // changing antivaping to 50
		}
		// open megamenu on hover for desktop
		this.$primaryNavItem.on('mouseover', e => {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				$('.js-nav-megamenu').removeClass('open');
				this.openSubmenu(e);
			}, delayDuration);
		}).on('mouseleave', e => {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.closeSubmenu(e);
			}, delayDuration);
		});

		// Hide Header on on scroll down
		$(window).scroll(e => {
			this.didScroll = true;
		});

		setInterval(() => {
			if (Util.getViewPort() === CONST.ViewPort.Desktop) {
				this.$body.removeClass('nav-open');
				this.$navToggle.removeClass('open');
				this.$nav.css('display', 'none');
				this.$navHeader.css('display', 'none');
			}

			if (this.didScroll && !$('body').hasClass('nav-open')) {
				this.hasScrolled();
				this.didScroll = false;
			}
		}, 100);

		$(window).on('resize', e => this.onResize(e));

		$(this.skipLink).focus(() => {
			let ScrollTop = document.documentElement.scrollTop;
			if (ScrollTop > 800) {
				$('html, body').animate({
					scrollTop: 0
				}, 2000);
			}
		});

		if (Util.getViewPort() === CONST.ViewPort.Mobile || Util.getViewPort() === CONST.ViewPort.Tablet) {
			this.$search.css('display', 'none');
		}
	}

	onResize(e) {
		this.setCornerHeight();
	}

	setCornerHeight() {
		$('.corner-img').each((i, obj) => {
			let height = $(obj).height() + 2;
			$(obj).css('font-size', `${height}px`);
		});
	}

	setWidgetHeight() {
		$('.grid-wrap.cards--grid .cards--grid').each((i, obj) => {
			if ($(obj).children('.image-container').length === $(obj).children('.widget').length) {
				$(obj).children('.widget').addClass('pl-0 pr-0 mb-0');
				$(obj).find('.image-container-inner').addClass('pt-100-calc-30');
			}
			$(obj).find('.widget').css('height', 'auto');
			$(obj).children('.widget').removeClass('pl-0 pr-0 mb-0');
			$(obj).find('.image-container-inner').removeClass('pt-100-calc-30');
		});
	}

	closeMegaMenu(e) {
		$('.js-nav-megamenu').removeClass('open');
	}

	closeSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').removeClass('open');
	}	

	hasScrolled() {
		let st = $(window).scrollTop();
		let headerHeight = $('.header').outerHeight() + 1;
		let bannerHeight = ($('.js-banner').hasClass('closed') || $('.js-banner') === undefined || $('.js-banner').length === 0) ? 0 : $('.js-banner').outerHeight();

		// Make sure they scroll more than delta
		if (Math.abs(this.lastScrollTop - st) <= this.delta) {
			return;
		}

		// If they scrolled down and are past the header, add class .header-up.
		// This is necessary so you never see what is "behind" the header.
		if (st > headerHeight) {
			this.$body.css('padding-top', headerHeight);

			if (st > this.lastScrollTop) {
				// Scroll Down
				this.$body.removeClass('header-down').addClass('header-up');
				this.$header.css('top', -headerHeight);
			}
			else if (st + $(window).height() < $(document).height()) {
				// Scroll Up
				this.$body.removeClass('header-up').addClass('header-down');
				this.$header.css('top', 0 - bannerHeight);
			}
		}
		else if (st <= (bannerHeight)) {
			this.$body.css('padding-top', 0);
			this.$header.css('top', 'auto');
			this.$body.removeClass('header-up').removeClass('header-down');
		}

		this.lastScrollTop = st;
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();

			const target = $(e.currentTarget);
			const parent = target.closest('li');

			$(parent).find('> ul').slideToggle();
			$(parent).toggleClass('open');
		}
	}

	openSubmenu(e) {
		const target = $(e.currentTarget);

		$(target).closest('li').find('.js-nav-megamenu').addClass('open');
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13 && target.hasClass('has-dropdown')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
			target.closest('li').find('.js-nav-megamenu').addClass('open');
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
			$prevItem.find('.js-nav-megamenu').removeClass('open');
		}
	}

	// toggle nav on mobile
	toggleNav(e) {
		const target = $(e.currentTarget);

		if (!$('body').hasClass('nav-open')) {
			if (!document.URL.includes('talk-about-vaping')) {
				this.scrollTop = $('header').offset().top;
				setTimeout(() => this.$body.css('position', 'fixed'), 500); 
			}						
		}
		else {
			this.$body.css('position', 'static');

			$('html, body').animate({
				scrollTop: this.scrollTop
			}, 0);
		}

		target.toggleClass('open');

		this.$body.toggleClass('nav-open');
		this.$searchToggle.removeClass('open');

		if (Util.getViewPort() === CONST.ViewPort.Mobile) {
			this.$nav.slideToggle();
			this.$navHeader.slideToggle();
		}

		this.$search.slideUp();
	}

	// toggle search on mobile
	toggleSearch(e) {
		this.$nav.slideUp();
		this.$navHeader.slideUp();

		$('.nav-megamenu').slideUp();
		this.$body.removeClass('nav-open');
		this.$navToggle.removeClass('open');
		this.$primaryNavItem.removeClass('open');

		this.$searchToggle.toggleClass('open');
		this.$search.slideToggle();
		this.$search.toggleClass('open');
		this.$search.find('input[type="search"]').focus();
	}

	// jump link menu button
	jumpLink(e) {
		$('.header-toggle').removeClass('open');
	}

    // Footer accordion expand/collapse
	footerAccordion(e) {
		if (Util.getViewPort() === CONST.ViewPort.Mobile) {
			e.stopPropagation();
			e.preventDefault();

			const target = $(e.currentTarget);

			target.toggleClass('open');
			target.closest('li').find('> ul').slideToggle();
		}      
	}
	
	setUpcomingEvents() {
		const upcomingEventData = $('#upcomingEvents');
		const upcomingEventCard = $('#upcomingEventsCard');
		$(upcomingEventCard).html($(upcomingEventData).html());
	}

	setupLiveChat() {
		$('.livechat-link').click((e) => {
			const chatID = $(e.target).data('livechat');
			window.liveagent.startChat(chatID);
		});
	}

	prepExternalLinks() {
		/*
		Rules for external links:
		1. Link is a pdf.
		2. Link is an external link (not in our hostname).
		*/
		let aMockElement = document.createElement('a');
		let pdfMatches = ['.pdf', '.pdf/'];
		let hostNames = [
			'lung.org',
			'www.lung.org',
			'action.lung.org',
			'ala-web-dev-mvc-app.azurewebsites.net',
			'ala-web-qa-mvc-app.azurewebsites.net',
			'ala-web-test-mvc-app.azurewebsites.net',
			'ala-web-staging-mvc-app.azurewebsites.net',
			'ala-web-prod-mvc-app.azurewebsites.net',
			'ala-web-prod-mvc-app-swap.azurewebsites.net',
			'ala-kentico-mvc-web-as-prod-v3.azurewebsites.net',
			'ala-kentico-mvc-web-as-prod-v3-swap.azurewebsites.net',
			'dev.lung.org',
			'qa.lung.org',
			'staging.lung.org',
			'localhost', // TO BE DELETED... Local testing of the site.
		];

		$('a').each((i, el) => {
			// link update error catching because of IE issues
			try {
				// Copy the href.
				aMockElement.href = el.href;
				// Clear the querystrings from href.
				aMockElement.search = '';
				aMockElement.href = aMockElement.href.replace(/\?/g, '');
				let linkPath = aMockElement.href.replace(window.location.origin, '');

				// If links match, set target _blank.
				if (
					(aMockElement.href.toLowerCase().indexOf('tel:') < 0)
					&& (linkPath.toLowerCase().indexOf('/') !== 0)
					&& (aMockElement.href.toLowerCase().indexOf('print()') < 0)
					&& (aMockElement.href.toLowerCase().indexOf('mailto:') < 0)
					&& (aMockElement.href.toLowerCase().indexOf('javascript') !== 0)
					&& (
						$.inArray(el.hostname, hostNames) < 0 // not on whitelist
						|| aMockElement.href.slice(-4) === pdfMatches[0] // or is PDF
						|| aMockElement.href.slice(-5) === pdfMatches[1]
						)
					) {
					$(el).prop('target', '_blank');
				}
			} catch (e) {
				// eslint-disable-next-line
				console.log(e);
			}
		});
    }
}

export default Layout;